import { IDynamicEventHandlerWithId } from '../../../utils/eventhandler-from-action';
import {
  openConfigStripEventHandler,
  recommendationItemClickedEventHandler,
} from '../../events';

export const onClickEventHandlers: IDynamicEventHandlerWithId[] = [
  openConfigStripEventHandler('parent', 'itemData'),
  recommendationItemClickedEventHandler(
    { provider: 'id:root', property: 'panelName' },
    { provider: 'id:root', property: 'panelTrackingId' },
    {
      provider: 'parent',
      property: 'itemData',
    },
  ),
];
